module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-03@2x.5880aa09.jpg";